import "./src/styles/animation.css"
import "./src/styles/documentation.css"
import "./src/styles/faq.css"
import "./src/styles/notification.css"
import "./src/styles/pricing.css"
import "./src/styles/style.css"
import "./src/styles/subscription.css"
// import "./src/styles/app.css"
